<div class="container cf-flex-column cf-justify-content-center cf-align-items-center">
  <h1 class="mat-headline-4" [translate]="'UI.LogoutSuccessful'"></h1>
  <button routerLink="/login" type="button" mat-raised-button class="login-button primary-button" aria-label="login">
    {{ 'UI.Login' | translate }}
  </button>
</div>
